import { render, staticRenderFns } from "./PhotoThumbnail.vue?vue&type=template&id=0df864be"
import script from "./PhotoThumbnail.vue?vue&type=script&lang=ts"
export * from "./PhotoThumbnail.vue?vue&type=script&lang=ts"
import style0 from "./PhotoThumbnail.vue?vue&type=style&index=0&id=0df864be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports